export const LEGAL_AGREEMENT_PATHS = {
	chekkitPayAccountAgreement: '/legal/chekkit-pay-account-agreement',
	aiPlatformUseAgreement: '/legal/ai-platform-use-agreement',
	aiEmployeeAgreement: '/legal/ai-employee-agreement',
	voiceCallData: '/legal/voice-call-data',
	voiceCallRecordingCompliance: '/legal/voice-call-recording-compliance',
	hipaaBaa: '/legal/hipaa-baa',
} as const;
